import { createReducer, createSelector } from '@reduxjs/toolkit';
import { all, call, fork, takeEvery } from 'redux-saga/effects';
import { KLEMAPPING_INCLUDE } from '../../constants/api';
import {
  addKleMappingsToStore,
  getAllHearingTypesSuccess,
  removeKleMappingsFromStore,
  updateKleMappingsInitialize,
} from '../actions/api';
import { KleMappingConnector } from '../connectors/kleMappingConnector';
import { getEntityId, getRelId } from '../helpers/apiHelpers';
import { removeItemFromList, updateDtoList } from '../helpers/reducerHelpers';
import { generateCreateApiCall } from '../helpers/sagaHelpers';
import {
  getIncludedData,
  getRequestData,
  selectAllFromApiState,
} from '../helpers/selectorHelpers';

// -------- Overview --------

// The following endpoints exist
//  - POST /hearingType/{hearingTypeId}/kleMappings

// -------- Reducer --------
const kleMappingReducer = createReducer(
  {
    all: [],
  },
  (builder) => {
    builder
      .addCase(getAllHearingTypesSuccess, (state, action) => {
        const data = getIncludedData(action);
        const kleMappings = data.filter(
          (include) => include.type === KLEMAPPING_INCLUDE,
        );
        return updateDtoList(state, 'all', kleMappings);
      })
      .addCase(addKleMappingsToStore, (state, action) => {
        const kleMappings = getRequestData(action);
        return updateDtoList(state, 'all', kleMappings);
      })
      .addCase(removeKleMappingsFromStore, (state, action) => {
        const idsToRemove = action.payload;
        return removeItemFromList(state, 'all', idsToRemove);
      });
  },
);
// -------- Sagas ---------
export function* kleMappingSaga() {
  yield all([fork(updateKleMappingsSaga)]);
}

function* updateKleMappingsSaga() {
  yield takeEvery(
    updateKleMappingsInitialize.type,
    generateCreateApiCall(KleMappingConnector, function* (connector, action) {
      return yield call(
        [connector, connector.updateKleMappings],
        action.payload.hearingTypeId,
        action.payload.dtos,
      );
    }),
  );
}

// -------- Selectors --------
const selectGetAllKleMappings = (state) =>
  selectAllFromApiState(state, 'kleMapping');
const allKleMappingsSelector = createSelector(
  selectGetAllKleMappings,
  (KleMappings) => KleMappings,
);

const kleMappingIdsByHearingTypeId = (hearingTypeId) =>
  createSelector(allKleMappingsSelector, (kleMappings) => {
    const kleMappingsByHearingTypeId = kleMappings.filter(
      (kleMapping) => getRelId(kleMapping, 'hearingType') === hearingTypeId,
    );
    return kleMappingsByHearingTypeId.map((kleMapping) =>
      getEntityId(kleMapping),
    );
  });

// -------- Exporting --------
export { allKleMappingsSelector, kleMappingIdsByHearingTypeId };
export default kleMappingReducer;
